import React from 'react';
import Chart from 'react-apexcharts';
import ChartCard from './shared/ChartCard';

const YearOverYearComparisonChart = ({ chartData = null, loading = false }) => {
  const hasData = chartData && Array.isArray(chartData.series) && chartData.series.length > 0 && Array.isArray(chartData.categories) && chartData.categories.length > 0;

  // Chart configuration - clean and simple
  const chartOptions = {
    chart: {
      type: 'area',
      height: 400,
      toolbar: {
        show: false // Remove toolbar completely
      },
      fontFamily: 'Arial, sans-serif',
      background: 'transparent',
      animations: {
        enabled: true,
        easing: 'easeinout',
        speed: 800,
        animateGradually: {
          enabled: true,
          delay: 150
        }
      }
    },
    stroke: {
      curve: 'smooth',
      width: 3
    },
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'light',
        type: 'vertical',
        shadeIntensity: 0.1,
        gradientToColors: undefined,
        inverseColors: false,
        opacityFrom: 0.3,
        opacityTo: 0.1,
        stops: [0, 100]
      }
    },
    dataLabels: {
      enabled: true,
      background: {
        enabled: true,
        foreColor: '#fff',
        padding: 4,
        borderRadius: 4,
        borderWidth: 1,
        borderColor: '#fff',
        opacity: 0.9
      },
      style: {
        fontSize: '11px',
        fontWeight: 600,
        colors: ['#374151'],
        fontFamily: 'Arial, sans-serif'
      },
      formatter: function (val) {
        return val + '%';
      }
    },
    markers: {
      size: 6,
      strokeWidth: 2,
      strokeColors: '#fff',
      hover: {
        size: 8,
        sizeOffset: 3
      }
    },
    xaxis: {
      categories: Array.isArray(chartData?.categories) ? chartData.categories : [],
      title: {
        text: 'Periods',
        style: {
          fontSize: '14px',
          fontWeight: 500,
          color: '#6B7280',
          fontFamily: 'Arial, sans-serif'
        }
      },
      labels: {
        style: {
          fontSize: '12px',
          fontWeight: 500,
          colors: '#374151',
          fontFamily: 'Arial, sans-serif'
        }
      },
      axisBorder: {
        show: true,
        color: '#E5E7EB',
        height: 1,
        width: '100%',
        offsetX: 0,
        offsetY: 0
      },
      axisTicks: {
        show: false
      }
    },
    yaxis: {
      title: {
        text: 'Completion Percentage (%)',
        style: {
          fontSize: '14px',
          fontWeight: 500,
          color: '#6B7280',
          fontFamily: 'Arial, sans-serif'
        }
      },
      labels: {
        formatter: function (val) {
          return val + '%';
        },
        style: {
          fontSize: '12px',
          colors: '#6B7280',
          fontWeight: 400,
          fontFamily: 'Arial, sans-serif'
        }
      },
      min: 0,
      max: 100,
      tickAmount: 5
    },
    colors: ['#06B6D4', '#10B981', '#F59E0B', '#EF4444'], // Teal, Green, Yellow, Red
    legend: {
      show: true,
      position: 'top',
      horizontalAlign: 'center',
      fontSize: '14px',
      fontWeight: 500,
      labels: {
        colors: '#374151',
        useSeriesColors: false
      },
      markers: {
        width: 16,
        height: 16,
        radius: 2,
        offsetX: 0,
        offsetY: 0
      },
      itemMargin: {
        horizontal: 15,
        vertical: 8
      },
      offsetY: 0
    },
    grid: {
      show: true,
      borderColor: '#E5E7EB',
      strokeDashArray: 0,
      xaxis: {
        lines: {
          show: false
        }
      },
      yaxis: {
        lines: {
          show: true
        }
      },
      padding: {
        top: 0,
        right: 30,
        bottom: 0,
        left: 20
      }
    },
  };

  return (
    <ChartCard
      title="Year-over-Year Comparison"
      icon="📅"
      description="Compare completion percentage trends across financial years"
      loading={loading}
      isEmpty={!hasData}
      skeletonType="lines"
      emptyIcon="📅"
      emptyTitle="No Year Comparison Data Available"
      emptyMessage="Select multiple financial years to compare performance trends."
      accentColor="#10B981"
      minHeight="400px"
    >
      <div style={{
        width: "100%",
        background: "#FAFBFF",
        borderRadius: "12px",
        border: "1px solid rgba(99,102,241,0.08)",
        padding: "20px",
      }}>
        <Chart
          options={chartOptions}
          series={Array.isArray(chartData?.series) ? chartData.series.map(s => ({
            ...s,
            data: Array.isArray(s?.data) ? s.data : []
          })) : []}
          type="area"
          height={400}
        />
      </div>
    </ChartCard>
  );
};

export default YearOverYearComparisonChart;